
import {
  defineComponent
} from 'vue'
import NavView from '../views/NavView.vue'
import {
  useDialog
} from 'naive-ui'
export default defineComponent({
  components: {
    NavView
  },
  /**
   * Global Components in project
   */
  setup() {
    // naive -> Dialog
    window.$dialog = useDialog()
  }
})
